import { lazy } from "react"
import { Navigate } from "react-router-dom"
// project import
import Loadable from "components/Loadable"
import MainLayout from "layout/MainLayout"
// render - dashboard
const DashboardDefault = Loadable(lazy(() => import("pages/dashboard")))
// const Location = Loadable(lazy(() => import('./../pages/location')));
const Appointments = Loadable(lazy(() => import("./../pages/appointments")))
const Configuration = Loadable(lazy(() => import("./../pages/configuration")))

// ==============================|| MAIN ROUTING ||============================== //
import { ToUserOrAdminLogin } from "helper/helper"

/**
 *
 * @param {boolean} isAuthenticated
 * @returns {import('react-router-dom').RouteObject[]}
 */
const MainRoutes = (isAuthenticated) => {
  return {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="dashboard" />,
        index: true,
      },
      {
        path: "dashboard",
        element: isAuthenticated ? (
          <DashboardDefault />
        ) : (
          <ToUserOrAdminLogin />
        ),
      },
      // {
      //   path: 'location',
      //   element: isAuthenticated ? <Location /> : <ToUserOrAdminLogin/>
      // },

      {
        path: "appointments",
        element: isAuthenticated ? <Appointments /> : <ToUserOrAdminLogin />,
      },
      {
        path: "config",
        element: isAuthenticated ? <Configuration /> : <ToUserOrAdminLogin />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  }
}

export default MainRoutes
